import React, { useState, useRef, useEffect } from "react";
import "./styles.css";
import { useCompanies } from "../../../hooks/companies";
import { useAuth } from "../../../hooks/auth";
import { useActiveProduct } from "../../../hooks/activeProduct";
import { useHistory, useLocation } from "react-router-dom";
import { ABA_PADRAO, abaDaUrl, urlComAba } from "./abaDaUrl";
import { temPermissao } from "../AuditoriaPedido/regras";
import { PERMISSAO_VER as PERMISSAO_DESPACHO } from "../DespachoLotes/regras";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
// no direct api import here (reverted instrumentation)

// custo
import ChartTotalCusto from "./componentsCusto/ChartTotalCusto";
import ChartTotalizadores from "./componentsCusto/ChartTotalizadores";
import IndicadoresFrete from "./componentsCusto/IndicadoresFrete";
import ChartFretePorKg from "./componentsCusto/ChartFretePorKg";
import ChartFretePorNf from "./componentsCusto/ChartFretePorNf";
import ChartContaFrete from "./componentsCusto/ChartContaFrete";
import ChartFretePorUF from "./componentsCusto/ChartFretePorUF";
import ChartStatusCte from "./componentsCusto/ChartStatusCte";
import ChartStatusDiv from "./componentsCusto/ChartStatusDiv";
import ChartStatusCtePago from "./componentsCusto/ChartStatusCtePago";
import ChartNfPorModalidade from "./componentsCusto/ChartNfPorModalidade";
import ChartFreteClienteUF from "./componentsCusto/ChartFreteClienteUF";
import ChartFretePorTransp from "./componentsCusto/ChartFretePorTransp";
import ChartFretePorNegocio from "./componentsCusto/ChartFretePorNegocio";
import ChartMediaFreteUF from "./componentsCusto/ChartMediaFreteUF";
import ChartMediaFreteTransp from "./componentsCusto/ChartMediaFreteTransp";
import ChartFretePorUfNF from "./componentsCusto/ChartFretePorUfNF";
import ChartFretePorTranspNF from "./componentsCusto/ChartFretePorTranspNF";
import MapFretePorUF from "./componentsCusto/MapFretePorUF";

// performance
import ChartOcorrenciasTratadas from "./componentsPerformance/ChartOcorrenciasTratadas";
import ChartOcorrenciasEmAberto from "./componentsPerformance/ChartOcorrenciasEmAberto";
import ChartFreteAdicional from "./componentsPerformance/ChartFreteAdicional";
import ChartStatusEntrega from "./componentsPerformance/ChartStatusEntrega";
import ChartDificuldadesEntrega from "./componentsPerformance/ChartDificuldadesEntrega";
import ChartMediaMensal from "./componentsCusto/ChartMediaMensal";
import ChartEntregaPorTransp from "./componentsPerformance/ChartEntregaPorTransp";
import ChartPrazoPorTransp from "./componentsPerformance/ChartPrazoPorTransp";
import ChartEntregaPorCentroCusto from "./componentsPerformance/ChartEntregaPorCentroCusto";
import ChartDevolucaoPorMes from "./componentsPerformance/ChartDevolucaoPorMes";
import IndicadoresEntrega from "./componentsPerformance/IndicadoresEntrega";

// despacho (PO1-3494, épico PO1-3493)
import IndicadoresDespacho from "./componentsDespacho/IndicadoresDespacho";
import ChartEtiquetasPorTransp from "./componentsDespacho/ChartEtiquetasPorTransp";
import ChartMotivosFalha from "./componentsDespacho/ChartMotivosFalha";
import LotesSituacao from "./componentsDespacho/LotesSituacao";
import ColetasSituacao from "./componentsDespacho/ColetasSituacao";
import ChartDespachoPorDia from "./componentsDespacho/ChartDespachoPorDia";
import QuadroDespacho from "./componentsDespacho/QuadroDespacho";

// cotação (PO1-3628, épico PO1-3620): só no GoBID
import CardsCotadoRealizado from "./componentsCotacao/CardsCotadoRealizado";
import CardsSavings from "./componentsCotacao/CardsSavings";

// cockpit
import ChartIntegracao from "./componentesCockpit/ChartIntegracao";
import ChartIntegracaoFat from "./componentesCockpit/ChartIntegracaoFat";
import ChartIntegracaoCte from "./componentesCockpit/ChartIntegracaoCte";
import ChartIntegracaoNfe from "./componentesCockpit/ChartIntegracaoNfe";
import ChartLogCTe from "./componentesCockpit/ChartLogCTe";
import ChartLogNF from "./componentesCockpit/ChartLogNF";

// auditoria
import ChartFaturasAuditoria from "./componentsAuditoria/ChartFaturasAuditoria";
import ChartFaturaSituacao from "./componentsAuditoria/ChartFaturaSituacao";
import CalendarFatura from "./componentsAuditoria/CalendarFatura";
import ChartFaturaPorTransp from "./componentsAuditoria/ChartFaturaPorTransp";
import ChartFaturasResumo from "./componentsAuditoria/ChartFaturasResumo";
import KanbanStatusFatura from "./componentsAuditoria/KanbanStatusFatura";
import ChartResumoAuditoria from "./componentsAuditoria/ChartResumoAuditoria";

// Aba "Despacho" (PO1-3494): só nos produtos com módulo de despacho e para quem
// vê Despacho › Lotes (mesma permissão de leitura).
const PRODUTOS_COM_DESPACHO = ["TRACKFY", "FLOW"];
// Aba "Cotação" (PO1-3628): cards do Cotado × Realizado e do Savings, só no GoBID.
const PRODUTOS_COM_COTACAO = ["GOBID"];

export default function Dashboard() {
  const history = useHistory();
  const location = useLocation();
  // PO1-3506: a aba fica na URL (`?aba=despacho`). Sem isso o ícone "Como usar
  // esta tela" não sabe em que aba o usuário está. Valor inválido = aba padrão.
  const [tab, setTab] = useState(() => abaDaUrl(location.search) || ABA_PADRAO);
  const { user } = useAuth();
  const { activeProduct } = useActiveProduct();
  const mostraDespacho =
    PRODUTOS_COM_DESPACHO.indexOf(activeProduct) !== -1 &&
    temPermissao(user, PERMISSAO_DESPACHO);
  const mostraCotacao = PRODUTOS_COM_COTACAO.indexOf(activeProduct) !== -1;

  // Grava a aba na URL sem empilhar histórico (replace), mantendo os outros
  // parâmetros; a aba padrão sai da URL.
  useEffect(() => {
    const atual = location.search || "";
    const nova = urlComAba(atual, tab);
    if (nova !== atual) history.replace({ pathname: location.pathname, search: nova });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);
  // orchestration: enable for specific tabs (non-auditoria). Many child components
  // already support `deferLoad` and `onRegisterFetch` (backward-compatible).
  const orchestratedTabs = useRef(
    new Set(["custo", "performance", "integracao", "despacho", "cotacao"])
  );
  const fetchRegistryRef = useRef(Object.create(null));
  const registerCounter = useRef(0);
  const CONCURRENCY = 5; // configurable concurrency for orchestrated fetches

  const registerFetch = (idOrFn, fnIfProvided) => {
    // registerFetch(name, fn) or registerFetch(fn)
    let id = null;
    let fn = null;
    if (typeof idOrFn === "string") {
      id = idOrFn;
      fn = fnIfProvided;
    } else {
      fn = idOrFn;
      id = `reg_${Date.now()}_${registerCounter.current++}`;
    }
    if (!fn) return () => {};
    fetchRegistryRef.current[id] = fn;
    // return unregister
    return () => {
      delete fetchRegistryRef.current[id];
    };
  };

  const runSequenceWithConcurrency = async (
    fns = [],
    concurrency = CONCURRENCY
  ) => {
    if (!fns.length) return [];
    const results = [];
    let idx = 0;
    const worker = async () => {
      while (true) {
        let i = idx++;
        if (i >= fns.length) break;
        const fn = fns[i];
        const start = Date.now();
        try {
          // ensure we treat return value as a promise
          const r = await Promise.resolve(fn());
          results[i] = { ok: true, value: r, durationMs: Date.now() - start };
        } catch (err) {
          results[i] = {
            ok: false,
            error: err,
            durationMs: Date.now() - start,
          };
        }
      }
    };

    const workers = [];
    for (let w = 0; w < Math.min(concurrency, fns.length); w++)
      workers.push(worker());
    await Promise.all(workers);
    return results;
  };

  // quando a aba muda para 'custo', execute as funções registradas em sequência
  const { empresa, transportadora } = useCompanies();

  // when tab changes to an orchestrated tab, run registered fetches
  useEffect(() => {
    // read current registry
    const registry = fetchRegistryRef.current;
    if (orchestratedTabs.current.has(tab)) {
      const fns = Object.values(registry);
      if (fns.length) {
        (async () => {
          try {
            await runSequenceWithConcurrency(fns, CONCURRENCY);
            fetchRegistryRef.current = Object.create(null);
          } catch (e) {
            console.error("orchestrator error", e);
            fetchRegistryRef.current = Object.create(null);
          }
        })();
      }
    } else {
      // non-orchestrated tabs: clear any leftover registrations
      fetchRegistryRef.current = Object.create(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, empresa, transportadora]);

  const changeActiveTab = (e, tadName) => {
    setTab(tadName);
  };

  // Trocou de produto (ou perdeu a permissão) com a aba Despacho aberta: volta
  // para a primeira aba em vez de ficar numa aba que não existe mais.
  useEffect(() => {
    if (tab === "despacho" && !mostraDespacho) setTab("custo");
  }, [tab, mostraDespacho]);
  // Idem para a aba Cotação sem GoBID (PO1-3628).
  useEffect(() => {
    if (tab === "cotacao" && !mostraCotacao) setTab("custo");
  }, [tab, mostraCotacao]);

  // no dev instrumentation (reverted)

  return (
    <div className="content">
      {/* instrumentation removed to restore baseline behavior */}
      <Row>
        <Col xs="12">
          <Nav className="nav-pills-info" pills>
            <NavItem>
              <NavLink
                data-toggle="tab"
                href="#"
                className={tab === "custo" ? "active" : ""}
                onClick={(e) => changeActiveTab(e, "custo")}
              >
                Custos de Frete
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-toggle="tab"
                href="#"
                className={tab === "performance" ? "active" : ""}
                onClick={(e) => changeActiveTab(e, "performance")}
              >
                Performance de Entrega
              </NavLink>
            </NavItem>
            {mostraDespacho ? (
              <NavItem>
                <NavLink
                  data-toggle="tab"
                  href="#"
                  className={tab === "despacho" ? "active" : ""}
                  onClick={(e) => changeActiveTab(e, "despacho")}
                >
                  Despacho
                </NavLink>
              </NavItem>
            ) : null}
            {mostraCotacao ? (
              <NavItem>
                <NavLink
                  data-toggle="tab"
                  href="#"
                  className={tab === "cotacao" ? "active" : ""}
                  onClick={(e) => changeActiveTab(e, "cotacao")}
                >
                  Cotação
                </NavLink>
              </NavItem>
            ) : null}
            <NavItem>
              <NavLink
                data-toggle="tab"
                href="#"
                className={tab === "integracao" ? "active" : ""}
                onClick={(e) => changeActiveTab(e, "integracao")}
              >
                Integração
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                data-toggle="tab"
                href="#"
                className={tab === "auditoria" ? "active" : ""}
                onClick={(e) => changeActiveTab(e, "auditoria")}
              >
                Auditoria de Frete
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent className="tab-space" activeTab={tab}>
            <TabPane tabId="custo">
              {tab === "custo" && (
                <>
                  {/* PO1-2712 (revisão pós-QA) — linha de indicadores estilo ticker no topo */}
                  <IndicadoresFrete
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("IndicadoresFrete", fn)
                    }
                  />
                  <ChartTotalCusto
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartTotalCusto", fn)
                    }
                  />
                  <ChartTotalizadores
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartTotalizadores", fn)
                    }
                  />
                  <Row>
                    <Col>
                      <ChartFretePorKg
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartFretePorKg", fn)
                        }
                      />
                    </Col>
                    <Col>
                      <ChartFretePorNf
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartFretePorNf", fn)
                        }
                      />
                    </Col>
                    <Col>
                      <ChartContaFrete
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartContaFrete", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <ChartMediaMensal
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartMediaMensal", fn)
                    }
                  />
                  <Row>
                    <Col>
                      <ChartFretePorUF
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartFretePorUF", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <MapFretePorUF
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("MapFretePorUF", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <ChartStatusCte
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartStatusCte", fn)
                        }
                      />
                    </Col>
                    <Col>
                      <ChartStatusDiv
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartStatusDiv", fn)
                        }
                      />
                    </Col>
                    <Col>
                      <ChartStatusCtePago
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartStatusCtePago", fn)
                        }
                      />
                    </Col>
                    <Col>
                      <ChartNfPorModalidade
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartNfPorModalidade", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <ChartFreteClienteUF
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartFreteClienteUF", fn)
                    }
                  />
                  {/* <ChartFretePorTransp /> */}
                  <Row>
                    <Col md={6}>
                      <ChartFretePorTransp
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartFretePorTransp", fn)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <ChartFretePorNegocio
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartFretePorNegocio", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <ChartMediaFreteUF
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartMediaFreteUF", fn)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <ChartMediaFreteTransp
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartMediaFreteTransp", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <ChartFretePorUfNF
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartFretePorUfNF", fn)
                    }
                  />
                  <ChartFretePorTranspNF
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartFretePorTranspNF", fn)
                    }
                  />
                </>
              )}
            </TabPane>
            <TabPane tabId="performance">
              {tab === "performance" && (
                <>
                  {/* PO1-2819: linha de KPIs no topo da aba, antes dos gráficos. */}
                  <IndicadoresEntrega
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("IndicadoresEntrega", fn)
                    }
                  />
                  <ChartDevolucaoPorMes
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartDevolucaoPorMes", fn)
                    }
                  />
                  <ChartEntregaPorCentroCusto
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartEntregaPorCentroCusto", fn)
                    }
                  />
                  <Row>
                    <Col md={12}>
                      <ChartEntregaPorTransp
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartEntregaPorTransp", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <ChartPrazoPorTransp
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartPrazoPorTransp", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <ChartTotalizadores
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartTotalizadores_perf", fn)
                    }
                  />
                  <Row>
                    <Col md={6}>
                      <ChartOcorrenciasTratadas
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartOcorrenciasTratadas", fn)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <ChartOcorrenciasEmAberto
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartOcorrenciasEmAberto", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <ChartFreteAdicional
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartFreteAdicional", fn)
                    }
                  />
                  <Row>
                    <Col md={6}>
                      <ChartStatusEntrega
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartStatusEntrega", fn)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <ChartDificuldadesEntrega
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartDificuldadesEntrega", fn)
                        }
                      />
                    </Col>
                  </Row>
                </>
              )}
            </TabPane>
            <TabPane tabId="cotacao">
              {tab === "cotacao" && mostraCotacao && (
                <>
                  {/* PO1-3628: os 8 cards leem o MESMO resumo (useResumoCotacao):
                      uma chamada ao Cotado × Realizado e uma ao Savings para a aba inteira. */}
                  <CardsCotadoRealizado
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("CardsCotadoRealizado", fn)
                    }
                  />
                  <CardsSavings
                    deferLoad={true}
                    onRegisterFetch={(fn) => registerFetch("CardsSavings", fn)}
                  />
                </>
              )}
            </TabPane>
            <TabPane tabId="despacho">
              {tab === "despacho" && mostraDespacho && (
                <>
                  {/* PO1-3494: os 6 blocos leem o MESMO resumo (useResumoDespacho):
                      uma chamada a /despacho/indicadores/resumo para a aba inteira.
                      PO1-3500: o Quadro tem a própria chamada (/quadro), uma só. */}
                  <IndicadoresDespacho
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("IndicadoresDespacho", fn)
                    }
                  />
                  <QuadroDespacho
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("QuadroDespacho", fn)
                    }
                  />
                  <Row>
                    <Col md={6}>
                      <ChartEtiquetasPorTransp
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartEtiquetasPorTransp", fn)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <ChartMotivosFalha
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ChartMotivosFalha", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <LotesSituacao
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("LotesSituacao", fn)
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <ColetasSituacao
                        deferLoad={true}
                        onRegisterFetch={(fn) =>
                          registerFetch("ColetasSituacao", fn)
                        }
                      />
                    </Col>
                  </Row>
                  <ChartDespachoPorDia
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartDespachoPorDia", fn)
                    }
                  />
                </>
              )}
            </TabPane>
            <TabPane tabId="integracao">
              {tab === "integracao" && (
                <>
                  <ChartIntegracao
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartIntegracao", fn)
                    }
                  />
                  <ChartLogCTe
                    deferLoad={true}
                    onRegisterFetch={(fn) => registerFetch("ChartLogCTe", fn)}
                  />
                  <ChartLogNF
                    deferLoad={true}
                    onRegisterFetch={(fn) => registerFetch("ChartLogNF", fn)}
                  />
                  <ChartIntegracaoFat
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartIntegracaoFat", fn)
                    }
                  />
                  <ChartIntegracaoCte
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartIntegracaoCte", fn)
                    }
                  />
                  <ChartIntegracaoNfe
                    deferLoad={true}
                    onRegisterFetch={(fn) =>
                      registerFetch("ChartIntegracaoNfe", fn)
                    }
                  />
                </>
              )}
            </TabPane>
            <TabPane tabId="auditoria">
              {tab === "auditoria" && (
                <>
                  <ChartFaturasAuditoria />
                  <ChartFaturasResumo />
                  <Row>
                    <Col md={6}>
                      <ChartFaturaSituacao />
                    </Col>
                    <Col md={6}>
                      <ChartFaturaPorTransp />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <ChartResumoAuditoria />
                    </Col>
                  </Row>
                  <section className="calendar-section">
                    <CalendarFatura />
                  </section>
                  <section className="kanban-section">
                    <KanbanStatusFatura />
                  </section>
                </>
              )}
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </div>
  );
}
